export const MAX_PAGES_TO_SHOW = 9;

export const PAGES_HALF = Math.floor(MAX_PAGES_TO_SHOW / 2);
